var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCurveSecondary = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1923.091 299.891",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2156 812.922h1923.091v-299.892c-259.424 396.225-1923.091 0-1923.091 0z",
    fill: "currentColor",
    transform: "translate(-2156 -513.03)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCurveSecondary, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/curve-secondary.47bfd88e.svg";
export { ForwardRef as ReactComponent };